import { createReducer, createActions } from 'reduxsauce';

const { Types, Creators } = createActions({
  fetchCoupons: null,
  addCoupon: ['coupon'],
  updateCoupon: ['coupon'],
  setCouponsLoading: ['loading'],
  setCoupons: ['couponsList'],
  setPagination: ['pagination'],
  changeItemsToDisplay: ['itemsToDisplay'],
  updateCouponFilterList: ['list'],
  loadCouponRequest: ['couponId'],
  setCouponData: ['data']
});

export const CouponsTypes = Types;
export default Creators;

/* ------- Initial State --------- */
export const INITIAL_STATE = {
  loading: false,
  couponsList: [],
  pagination: {},
  itemsToDisplay: 100,
  list: {
    title: [],
    usagePerUser: [],
    propertyID: [],
    recurrences: [],
    serviceType: [],
    aliases: [],
    discount: [],
    office: [],
    type: []
  },
  data: {}
};

/* ------- Selectors --------- */
export const CouponsSelectors = {
  selectLoading: state => state.coupons.loading,
  selectCouponsList: state => state.coupons.couponsList,
  selectNoOfItemsDiplay: state => state.coupons.itemsToDisplay,
  selectList: state => state.coupons.list,
  selectCouponData: state => state.coupons.data
};

/* -------- Reducers ---------- */
export const setLoading = (state, { loading }) => ({
  ...state,
  loading
});

export const setCoupons = (state, { couponsList }) => {
  return {
    ...state,
    couponsList
  };
};

export const addCoupon = (state, { coupon }) => {
  return {
    ...state,
    couponsList: [coupon, ...state.couponsList]
  };
};

export const updateCoupon = (state, { coupon }) => {
  return {
    ...state,
    data: coupon
  };
};

export const setPagination = (state, { pagination }) => {
  return {
    ...state,
    pagination
  };
};

export const changeItemsToDisplay = (state, { itemsToDisplay }) => {
  return {
    ...state,
    itemsToDisplay
  };
};

export const updateList = (state, { list }) => {
  return {
    ...state,
    list: { ...state.list, ...list }
  };
};

export const setCouponData = (state, { data }) => {
  return {
    ...state,
    data
  };
};

/* -------- Hookup Reducers to Types -------- */
export const reducer = createReducer(INITIAL_STATE, {
  [Types.SET_COUPONS_LOADING]: setLoading,
  [Types.SET_COUPONS]: setCoupons,
  [Types.SET_PAGINATION]: setPagination,
  [Types.CHANGE_ITEMS_TO_DISPLAY]: changeItemsToDisplay,
  [Types.UPDATE_COUPON_FILTER_LIST]: updateList,
  [Types.ADD_COUPON]: addCoupon,
  [Types.UPDATE_COUPON]: updateCoupon,
  [Types.SET_COUPON_DATA]: setCouponData
});
